import get from 'lodash/get';

export const getVisibleChartSources = chart =>
  get(chart, 'data.datasets', []).reduce((sources, { label }, idx) => {
    const source = label.split('.')[0];
    const meta = chart.getDatasetMeta(idx);

    return !sources.includes(source) && !meta.hidden
      ? [...sources, source]
      : sources;
  }, []);



// WEBPACK FOOTER //
// ./src/components/common/Charts/helpers/getVisibleChartSources.js